<template>
  <v-container>
    <v-row>
      <v-col col="6">
        <v-btn color="secondary" v-if="buttonShow('create')" outlined @click="createPayoutModal = true">
          <v-icon left>mdi-newspaper-plus</v-icon>Create
        </v-btn>
        <v-btn color="secondary" v-if="buttonShow('import')" outlined @click="$refs.outcome.click()">
          <v-icon left>mdi-home-import-outline</v-icon>Import
        </v-btn>
        <v-btn outlined color="secondary" @click="refresh()">
          <v-icon>mdi-autorenew</v-icon>Refresh
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" lg="3" sm="6">
        <total-number
          :total="totalAmount"
          :title="'Total Payout'"
          :subtitle="'Total payout to influencers'"
        ></total-number>
      </v-col>
      <v-col cols="12" md="4" lg="3" sm="6">
        <total-number
          :total="totalThisWeek"
          :title="'Total this week'"
          :subtitle="thisWeek"
        ></total-number>
      </v-col>
      <v-col cols="12" md="4" lg="3" sm="6">
        <total-number
          :total="totalThisMonth"
          :title="'Total this month'"
          :subtitle="thisMonth"
        ></total-number>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" lg="4" sm="6">
        <!-- <v-dialog
          ref="dialog"
          v-model="selectDateModal"
          :return-value.sync="dates"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="dateRangeText"
              label="Range"
              prepend-inner-icon="event"
              outlined
              width="200"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dates" range>
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="selectDateModal = false">Cancel</v-btn>
            <v-btn text color="secondary" @click="$refs.dialog.save(dates)">OK</v-btn>
          </v-date-picker>
        </v-dialog>-->
        <v-text-field
          label="Search"
          v-on:keyup.enter="filter()"
          hint="Press 'Enter' to search"
          v-model="searchKeyWords"
          placeholder="Campaign name, Instagram handle"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- <line-chart :chart-data="chartData" :options="options" /> -->
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagging"
      :server-items-length="totalItems"
      class="elevation-1 mt-5"
      :item-class="rowColor"
    >
      <template v-slot:[`item.amount`]="{ item }">${{ item.amount | thousandSeprator }}</template>
      <template v-slot:[`item.instagramHandle`]="{ item }">
        <a
          :href="'https://instagram.com/' + item.instagramHandle"
          target="_blank"
        >@{{ item.instagramHandle }}</a>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div class="item-status">
          <p class="status-label" @click="openEditItem(item)" v-if="!item.statusEdit">{{item.status}}</p>
          <v-combobox
            :items="statuses"
            hide-details="auto"
            v-model="item.status"
            @change="updateItemStatus(item)"
            dense
            outlined
            v-else
          >
          </v-combobox>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }" v-if="buttonShow('actions')">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" small dense v-bind="attrs" v-on="on">Actions</v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(action, index) in menus"
              :key="index"
              @click="doAction(action.value, item)"
            >
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <!-- Create payout records -->
    <create-payout-record
      :value="createPayoutModal"
      :mode="mode"
      :data="data"
      v-model="createPayoutModal"
      @created="payoutCreated"
    ></create-payout-record>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <input
      type="file"
      accept=".xlsx"
      id="outcome"
      ref="outcome"
      style="display: none"
      @change="perpareImport"
    />
  </v-container>
</template>
<script>
// import campaignAPIs from '../Campaign/campaignAPIs';
// import FinanceDataTable from './FinanceDataTable';
import Loading from 'vue-loading-overlay';
import LineChart from '../../charts/LineChart';
import CreatePayoutRecord from './CreatePayoutRecordModal';
import TotalNumber from './TotalNumber';
import paymentAPIs from './paymentAPIs';
import config from '@/config';
export default {
  components: {
    LineChart,
    TotalNumber,
    Loading,
    CreatePayoutRecord
  },
  data() {
    return {
      thisWeek: null,
      thisMonth: null,
      mode: 'new',
      data: null,
      menus: [
        { title: 'Edit', value: 'edit' },
        { title: 'Delete', value: 'delete' }
      ],
      searchKeyWords: null,
      selectDateModal: false,
      createPayoutModal: false,
      totalThisMonth: 0,
      totalThisWeek: 0,
      totalAmount: 0,
      totalItems: 0,
      isLoading: false,
      dates: [],
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 10
      },
      items: [],
      headers: [
        {
          text: 'Received Name',
          value: 'receivingName',
          sortable: false
        },
        {
          text: 'Instagram/TikTok Handle',
          value: 'handle',
          sortable: false
        },
        {
          text: 'CS Name',
          value: 'csName',
          sortable: false
        },
        {
          text: 'Amount',
          value: 'amount',
          sortable: false
        },
        {
          text: 'Campaign',
          value: 'campaignName',
          sortable: false
        },
        {
          text: 'REF',
          value: 'REF',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false
        },
        {
          text: 'Approval Date',
          value: 'approvalDate',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ],
      campaigns: [],
      totalCampaigns: 0,
      statuses: ['APPROVED', 'PENDING APPROVAL', 'ON_HOLD', 'REJECTED'],
      createdIds: [],
      updatedIds: []
    };
  },
  watch: {
    pagging(newValue) {
      this.findAll(newValue);
    }
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  methods: {
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['financial'][type];

      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }

      return false;
    },
    async perpareImport(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      const file = uploadedFiles[0];
      let formData = new FormData();
      formData.append('outcome', file);
      this.isLoading = true;
      const result = await paymentAPIs.importPaymoutRecords(formData);
      this.isLoading = false;
      const total = result.totalRecords || 0;
      const created = result.created || 0;
      const updated = result.updated || 0;
      let html = ''
      this.createdIds = []
      this.updatedIds = []
      if (created.length > 0) {
        this.createdIds = created.map(c => c.id)
        html += `${created.length}/${total} records were created!<br>`
      }
      if (updated.length > 0) {
        this.updatedIds = updated.map(u => u.id)
        html += `${updated.length}/${total} records were updated!`
      }
      this.$swal({
        type: 'success',
        title: 'Import successfully',
        html
      });
      this.refresh();
    },
    create() {
      this.createPayoutModal = true;
      this.mode = 'new';
      this.data = null;
    },
    edit(item) {
      this.createPayoutModal = true;
      this.mode = 'edit';
      this.data = Object.assign({}, item);
    },
    doAction(action, item) {
      switch (action) {
        case 'edit':
          this.edit(item);
          break;
        case 'delete':
          this.delete(item);
          break;
        default:
          return;
      }
    },
    async delete(item) {
      try {
        if (!item) return;
        const id = item.id;
        const result = await this.$swal({
          icon: 'warning',
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        });
        if (result.value) {
          await paymentAPIs.deletePayoutRecords(id);
          this.refresh();
          this.$swal({
            icon: 'success',
            text: 'Deleted!'
          });
        }
      } catch (error) {
        const message = error.message || 'Cannot delete this item';
        this.$swal({
          icon: 'error',
          text: message
        });
      }
    },
    filter() {
      const keywords = this.searchKeyWords;
      if (!keywords) { this.findAll(); return; }
      this.findAll({ q: keywords });
    },
    refresh() {
      this.findAll();
      this.getSummary();
      this.$refs.outcome.value = null;
    },
    async getSummary() {
      try {
        this.isLoading = true;
        const resp = await paymentAPIs.getSummary();
        if (resp.success) {
          const data = resp.data;
          this.totalThisMonth = data.totalThisMonth;
          this.totalThisWeek = data.totalThisWeek;
          this.totalAmount = data.totalPayout;
          this.totalItems = data.totalItems;
          const week = data.week || {};
          this.thisWeek = `${week.startTime} to ${week.endTime}`;
          this.thisMonth = data.month;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async findAll(filter = {}) {
      try {
        this.isLoading = true;
        const resp = await paymentAPIs.getPayouts(filter);
        if (resp.success) {
          const data = resp.data;
          this.items = data.outcomes.map((item) => {
            item.campaignName = item.campaign ? item.campaign.name : ''
            item.csName = item.cs ? item.cs.map(e => e.name).join(',') : ''
            item.salePersonName = item.salePersons ? item.salePersons.name : ''
            item.clientName = item.client ? item.client.name : ''
            if (this.createdIds.includes(item.id)) {
              item.color = 'yellow lighten-5'
            } else if (this.updatedIds.includes(item.id)) {
              item.color = 'blue lighten-4'
            }
            return item;
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    payoutCreated() {
      this.refresh();
    },
    async updateItemStatus(item) {
      try {
        const resp = await paymentAPIs.updatePayoutStatus(item.id, {status: item.status});
        if (resp.success) {
          item.statusEdit = false
        }
      } catch (error) {
        this.$swal({
          text: 'Error on Status Update',
          icon: 'error'
        });
        console.error(error);
      }
    },
    openEditItem(item) {
      this.items = this.items.map((itemOne) => {
        if (itemOne.id === item.id) {
          itemOne.statusEdit = true
        }
        return itemOne
      })
    },
    rowColor(item) {
      if (item.color) return item.color
      return ''
    }
  },
  mounted() {
    this.getSummary()
    /* eslint-env jquery */
    const onClickOutside = (e) => {
      if (e.target.className &&
      !e.target.className.includes('status') &&
      !e.target.className.includes('v-list-item__title') &&
      !e.target.className.includes('v-list-item')) {
        this.items = this.items.map((itemOne) => {
          itemOne.statusEdit = false
          return itemOne
        })
      }
    };
    window.addEventListener('click', onClickOutside)
  }
};
</script>
<style scoped>
.status-label {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// MoneyOut.vue?84d57a42